import './utils/pollyfills';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueClipboard from 'vue-clipboard2';
import VueRecaptcha from 'vue-recaptcha';

import App from './App.vue';
import router from './router';
import Components from './components';

import globalMix from './utils/mixins';

import './scss/main.scss';

Vue.use(BootstrapVue);
Vue.use(Components);

Vue.use(VueClipboard);
Vue.component('VueRecaptcha', VueRecaptcha);
Vue.mixin(globalMix);

Vue.config.productionTip = false;

new Vue({
  router,
  data: {
    binBbva: '',
  },
  render: h => h(App),
}).$mount('#app');
